import { ImageWidget } from "./ImageWidget"

export const widgets = ({ bucket }: any) => ({
  imageWidget: ImageWidget({ bucket: bucket }),
})
